import React from 'react';
import { useNavigate } from 'react-router-dom';

const ExportTransactionsButton = ({ portfolioId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!portfolioId) return;
    navigate('/transactions/export');
  };

  return (
    <button
      onClick={handleClick}
      disabled={!portfolioId}
      className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      Export
    </button>
  );
};

export default ExportTransactionsButton; 